import { render } from "./homePagePromo.vue?vue&type=template&id=540e0aef&scoped=true&ts=true"
import script from "./homePagePromo.vue?vue&type=script&lang=ts"
export * from "./homePagePromo.vue?vue&type=script&lang=ts"

import "./homePagePromo.vue?vue&type=style&index=0&id=540e0aef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540e0aef"]])

export default __exports__